import {colors} from 'theme';

export const Container = {
  variants: {
    'white-block': {
      borderRadius: 'md',
      bg: colors.white,
      p: '1rem',
      maxW: 'unset',
    },
  },
};

export const Button = {
  variants: {
    primary: {
      borderRadius: 'md',
      bg: colors.pink,
      h: '46px',
      color: colors.white,
      px: '32px',
      _hover: {
        _disabled: {
          bg: colors.pink,
        },
      },
    },
    gray: {
      borderRadius: 'md',
      bg: colors.lightGray,
      h: '50px',
      color: colors.black,
      px: '32px',
      _active: {
        border: 'none',
      },
    },
    favorite: {
      w: '1rem',
      h: '2.5rem',
      borderRadius: '50%',
      bg: 'rgba(0, 0, 0, 0.2)',
      bgPosition: 'center',
      bgRepeat: 'no-repeat',
      p: 0,
      position: 'absolute',
      top: 15,
      right: '15px',
      _focus: {
        boxShadow: 'none',
      },
    },
    counter: {
      tabIndex: 1,
      bg: colors.lightGray,
      borderRadius: '1rem',
      w: '50px',
      h: '50px',
      p: 0,
    },
    whiteBg: {
      border: '1px solid',
      borderColor: colors.borderGray,
      borderRadius: '16px',
      bg: colors.white,
      _hover: {bg: colors.lightGray},
    },
    outline: {
      border: '1px solid',
      borderColor: colors.black,
      fontSize: '14px',
      fontWeight: 600,
      minH: '45px',
    },
  },
};

export const Heading = {
  variants: {
    section: {
      fontSize: '36px',
      lineHeight: '44px',
      fontWeight: 'bold',
      pb: '30px',
      color: colors.lightBlack,
    },
  },
};

export const Text = {
  baseStyle: {
    fontSize: '1rem',
    fontWeight: 'bold',
  },
};

export const Textarea = {
  variants: {
    basic: {
      bg: colors.lightGray,
      fontWeight: 'medium',
      fontSize: '14px',
      border: 'none',
      resize: 'none',
      _placeholder: {
        color: colors.textGray,
      },
    },
  },
  defaultProps: {
    variant: 'basic',
  },
};
